__turbopack_context__.v({
  "wrapper": "rQNega_wrapper",
});
